import * as t from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/TextAlignJustify.es.js";
const e = t.forwardRef((o, i) => /* @__PURE__ */ t.createElement(r, { ref: i, ...o, weights: s }));
e.displayName = "TextAlignJustifyIcon";
const f = e;
export {
  f as TextAlignJustify,
  e as TextAlignJustifyIcon
};
